export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto bg-background-100 rounded-2xl p-6 md:p-10 text-center">
          <div className="w-16 h-16 rounded-2xl bg-primary-500/10 flex items-center justify-center mx-auto mb-5">
            <i className="ri-mail-send-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            如果您有91国产视频资源推荐、内容合作意向或使用中的任何问题，欢迎通过以下方式与我们取得联系。我们重视每一位影迷的反馈与建议。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <span className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-background-50 border border-background-200 text-sm font-medium text-foreground-700 cursor-pointer whitespace-nowrap">
              <i className="ri-mail-line text-primary-500"></i>
              contact@91video.com
            </span>
            <span className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-background-50 border border-background-200 text-sm font-medium text-foreground-700 cursor-pointer whitespace-nowrap">
              <i className="ri-wechat-line text-primary-500"></i>
              官方公众号
            </span>
            <span className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-background-50 border border-background-200 text-sm font-medium text-foreground-700 cursor-pointer whitespace-nowrap">
              <i className="ri-question-answer-line text-primary-500"></i>
              在线反馈
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}